import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import baseAreaRepo from '@/api/basic-setting/area';
import dialogMethodMixin from '@/mixins/dialog/method';

/* eslint-disable */
/**
 * 针对formData表单
 * tips: 表单值绑定应使用 v-model="formData.xxx"
 */
export default {
  mixins: [dialogMethodMixin],
  data: function data() {
    return {
      // 服务项目列表字典
      areaDict: [],
      // 楼宇字典
      buildingDict: [],
      // 道路字典
      roadDict: [],
      // 楼层字典
      floorDict: [],
      // 房间字典
      roomDict: []
    };
  },
  methods: {
    /**
     * 初始化字典
     */
    initDialogAreaDict: function () {
      var _initDialogAreaDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              params = _objectSpread(_objectSpread({}, params), {}, {
                status: 0
              });
              _context.next = 4;
              return baseAreaRepo.loadAreaDict(params);
            case 4:
              this.areaDict = _context.sent;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initDialogAreaDict() {
        return _initDialogAreaDict.apply(this, arguments);
      }
      return initDialogAreaDict;
    }(),
    /**
     * 获取楼宇字典
     */
    loadDialogBuildingDict: function () {
      var _loadDialogBuildingDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var areaId, buildingType;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              areaId = this.getDialogFormValue('areaId');
              buildingType = this.getDialogFormValue('buildingType');
              _context2.next = 4;
              return baseAreaRepo.loadBuildingDict({
                areaId: areaId,
                buildingType: buildingType
              });
            case 4:
              this.buildingDict = _context2.sent;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadDialogBuildingDict() {
        return _loadDialogBuildingDict.apply(this, arguments);
      }
      return loadDialogBuildingDict;
    }(),
    /**
     * 获取道路字典
     */
    loadDialogRoadDict: function () {
      var _loadDialogRoadDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var areaId;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              areaId = this.getDialogFormValue('areaId');
              _context3.next = 3;
              return baseAreaRepo.loadRoadDict({
                areaId: areaId
              });
            case 3:
              this.roadDict = _context3.sent;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadDialogRoadDict() {
        return _loadDialogRoadDict.apply(this, arguments);
      }
      return loadDialogRoadDict;
    }(),
    /**
     * 获取楼层字典
     */
    loadDialogFloorDict: function () {
      var _loadDialogFloorDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var areaId, buildingId;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              areaId = this.getDialogFormValue('areaId');
              buildingId = this.getDialogFormValue('buildingId');
              _context4.next = 4;
              return baseAreaRepo.loadFloorDict({
                areaId: areaId,
                buildingId: buildingId
              });
            case 4:
              this.floorDict = _context4.sent;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function loadDialogFloorDict() {
        return _loadDialogFloorDict.apply(this, arguments);
      }
      return loadDialogFloorDict;
    }(),
    /**
     * 获取房间字典
     */
    loadDialogRoomDict: function () {
      var _loadDialogRoomDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var areaId, buildingId, floorId;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              areaId = this.getDialogFormValue('areaId');
              buildingId = this.getDialogFormValue('buildingId');
              floorId = this.getDialogFormValue('floorId');
              _context5.next = 5;
              return baseAreaRepo.loadRoomDict({
                areaId: areaId,
                buildingId: buildingId,
                floorId: floorId
              });
            case 5:
              this.roomDict = _context5.sent;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function loadDialogRoomDict() {
        return _loadDialogRoomDict.apply(this, arguments);
      }
      return loadDialogRoomDict;
    }(),
    /**
     * 区域级联, 同时清空下级选项值，新增或查询时使用
     *
     * @param val
     */
    onDialogAreaIdChange: function onDialogAreaIdChange(val) {
      var _this = this;
      this.buildingDict = [];
      this.roadDict = [];
      this.resetDialogFormValue('buildingId');
      this.resetDialogFormValue('roadId');
      this.onDialogBuildingIdChange(null);
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this.loadDialogBuildingDict();
        _this.loadDialogRoadDict();
      });
    },
    /**
     * 区域级联, 不清空下级选项值，编辑时使用
     *
     * @param val
     */
    onDialogAreaIdChangeOnly: function onDialogAreaIdChangeOnly(val) {
      var _this2 = this;
      this.buildingDict = [];
      this.roadDict = [];
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this2.loadDialogBuildingDict();
        _this2.loadDialogRoadDict();
      });
    },
    /**
     * 楼宇类型-楼宇级联, 同时清空下级选项值，新增或查询时使用
     *
     * @param val
     */
    onDialogBuildingTypeChange: function onDialogBuildingTypeChange(val) {
      var _this3 = this;
      this.buildingDict = [];
      this.resetDialogFormValue('buildingId');
      this.onDialogBuildingIdChange(null);
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this3.loadDialogBuildingDict();
      });
    },
    /**
     * 楼宇类型级联, 不清空下级选项值，编辑时使用
     *
     * @param val
     */
    onDialogBuildingTypeChangeOnly: function onDialogBuildingTypeChangeOnly(val) {
      var _this4 = this;
      this.buildingDict = [];
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this4.loadDialogBuildingDict();
      });
    },
    /**
     * 楼宇-楼层级联, 同时清空下级选项值，新增或查询时使用
     *
     * @param val
     */
    onDialogBuildingIdChange: function onDialogBuildingIdChange(val) {
      var _this5 = this;
      this.floorDict = [];
      this.resetDialogFormValue('floorId');
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this5.loadDialogFloorDict();
      });
    },
    /**
     * 楼宇-楼层级联, 不清空下级选项值，编辑时使用
     *
     * @param val
     */
    onDialogBuildingIdChangeOnly: function onDialogBuildingIdChangeOnly(val) {
      var _this6 = this;
      this.floorDict = [];
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this6.loadDialogFloorDict();
      });
    },
    /**
     * 楼层房间联动, 同时清空下级选项值，新增或查询时使用
     *
     * @param val
     */
    onDialogFloorIdChange: function onDialogFloorIdChange(val) {
      var _this7 = this;
      this.roomDict = [];
      this.resetDialogFormValue('roomId');
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this7.loadDialogRoomDict();
      });
    },
    /**
     * 楼层房间联动, 不清空下级选项值，编辑时使用
     *
     * @param val
     */
    onDialogFloorIdChangeOnly: function onDialogFloorIdChangeOnly(val) {
      var _this8 = this;
      this.roomDict = [];
      if (!val) {
        return;
      }
      this.$nextTick(function () {
        _this8.loadDialogRoomDict();
      });
    }
  }
};